import type { NavigationItem } from "../types";

export interface UserProfileMenuProps {
  navigationItems?: NavigationItem[];
  visibleItems?: NavigationItem[];
  hiddenItems?: NavigationItem[];
  onSave?: (items: NavigationItem[]) => void;
  onReset?: () => void;
  onToggleVisibility?: (itemId: string) => void;
  onMoveUp?: (index: number) => void;
  onMoveDown?: (index: number) => void;
  onMoveChildUp?: (parentId: string, childId: string) => void;
  onMoveChildDown?: (parentId: string, childId: string) => void;
  onToggleChildVisibility?: (parentId: string, childId: string) => void;
}

export interface AppUserLike {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

export function getUserTypeDisplay(params: {
  isAdmin: boolean;
  isEmployee: boolean;
  isClientUser: boolean;
}): string {
  if (params.isAdmin) return "Admin";
  if (params.isEmployee) return "Employee";
  if (params.isClientUser) return "Client";
  return "User";
}

export function getUserInitials(appUser: AppUserLike | null | undefined): string {
  if (appUser?.first_name && appUser?.last_name) {
    return `${appUser.first_name[0]}${appUser.last_name[0]}`.toUpperCase();
  }
  if (appUser?.first_name) {
    return appUser.first_name.slice(0, 2).toUpperCase();
  }
  if (appUser?.email) {
    return appUser.email.slice(0, 2).toUpperCase();
  }
  return "U";
}

export function getDisplayName(appUser: AppUserLike | null | undefined): string {
  if (appUser?.first_name && appUser?.last_name) {
    return `${appUser.first_name} ${appUser.last_name}`;
  }
  if (appUser?.first_name) {
    return appUser.first_name;
  }
  if (appUser?.email) {
    return appUser.email.split("@")[0];
  }
  return "User";
}
